import axios from "axios";
import { endpoint } from "../../config/app.config";
import { clearCookie, getCookie, setParentDomainCookie } from "../../utils/cookies";

const { token, reset, sub, user } = getCookie()

export async function getManufacturerDetail(companyName) {
  clearCookie()
  return axios
    .get(`${endpoint}/api/manufacturer/${companyName}`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
}

export async function getCorporatePartnerDetail() {
  clearCookie()
  return axios
    .get(`${endpoint}/api/corporatepartner`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    })
}

export async function getCorporatepartner(companyName) {
  clearCookie()
  return axios
    .get(`${endpoint}/api/corporatepartner/${companyName}`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data
    })
    .catch((err) => {
      throw err;
    })
}
